export enum CustomizeSettingsEnum {
  THEME = 'THEME',
  LOCALIZATION = 'LOCALIZATION',
}
